import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_gestor-clientes-nss/artifacts/zdemw092_ChatGPT%20Image%2019%20sept%202026%2C%2005_05_17%20p.m..webp";

export default function Login() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    (async () => {
      try {
        await api.get("/auth/me");
        navigate("/dashboard", { replace: true });
      } catch {
        setChecking(false);
      }
    })();
  }, [navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="animate-pulse text-yellow-400 text-sm" data-testid="login-loading">Cargando…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4 py-10 bg-black overflow-hidden">
      {/* Background logo */}
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-contain opacity-20"
        style={{ backgroundImage: `url(${LOGO_URL})` }}
        aria-hidden
      />
      {/* Radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.85) 70%)",
        }}
        aria-hidden
      />

      <div className="relative w-full max-w-md rounded-3xl overflow-hidden shadow-2xl border border-yellow-500/40 bg-black/70 backdrop-blur-xl">
        <div className="p-10 flex flex-col items-center text-center">
          <img src={LOGO_URL} alt="Luis Pensiones" className="w-40 h-40 object-contain mb-4 drop-shadow-[0_0_25px_rgba(212,175,55,0.5)]" />
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 text-[11px] font-semibold tracking-wider uppercase">
            Portafolio · Pensiones IMSS
          </div>
          <h1 className="mt-6 font-heading text-3xl font-extrabold text-yellow-400 tracking-tight">
            Bienvenido
          </h1>
          <p className="mt-2 text-neutral-300 text-sm max-w-xs">
            Ingresa con tu cuenta de Google para acceder a tu portafolio privado.
          </p>

          <Button
            onClick={handleGoogleLogin}
            data-testid="google-login-button"
            className="mt-8 w-full h-12 bg-yellow-400 text-black hover:bg-yellow-300 border border-yellow-500 shadow-lg rounded-xl font-semibold"
          >
            <svg className="w-5 h-5 mr-3" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
            </svg>
            Continuar con Google
          </Button>

          <p className="mt-8 text-[11px] text-neutral-400 leading-relaxed">
            Cada asesor accede únicamente a su propio portafolio.
          </p>
        </div>
      </div>
    </div>
  );
}
